import script from "./ParticipantsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantsModal.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantsModal.vue?vue&type=style&index=0&id=0d33e760&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d33e760"]])

export default __exports__